import "homepage/homepage.css"

document.addEventListener("DOMContentLoaded", async () => {
  // Gegen einfache Adress-Crawler, siehe HomepageHelper#homepage_obfuscated_email
  document.querySelectorAll("[data-obfuscated-email]").forEach((el) => {
    const email = atob(el.dataset.obfuscatedEmail).split("").reverse().join("")
    const link = document.createElement("a")
    link.href = `mailto:${email}`
    link.textContent = email
    el.replaceChildren(link)
  })

  const graphs = [
    ["[data-network-graph]", "networkGraph", () => import("homepage/NetworkGraph.vue")],
    ["[data-platform-graph]", "platformGraph", () => import("homepage/PlatformGraph.vue")],
  ].filter(([selector]) => document.querySelector(selector))
  if (!graphs.length) return

  const { default: Vue } = await import("vue")
  graphs.forEach(async ([selector, key, load]) => {
    const el = document.querySelector(selector)
    const { default: component } = await load()
    const props = JSON.parse(el.dataset[key])
    new Vue({ render: (h) => h(component, { props }) }).$mount(el)
  })
})
